

export default {
    data() {
        return {
            ref: null,
            openNavBar: false,
        };
    },
    methods: {
        scrollToCampus() {
            const element = document.getElementById("campusMainPage");
            element.scrollIntoView({ behavior: 'smooth' });
        },
        scrollToCampus2() {
            const element2 = document.getElementById("campusMainPage");
            element2.scrollIntoView({ behavior: 'smooth' });
        },
        scrollToDiplomes() {
            const element = document.getElementById("diplomes");
            element.scrollIntoView({ behavior: 'smooth' });
        },
    }
}
